<template>
<div class="container">
  <div class="jumbotron text-xs-center">
    <div v-if="isConfirmed" class="row">
      <div class ="col-md-8">
        <h1 class="display-3">Pronto!</h1>
        <h3 class="display-5">Sua submissão <strong>{{ requestId }}</strong> foi recebida com sucesso!</h3>
        <p class="lead"><strong>Favor checar seu e-mail</strong> com os detalhes da sua inscrição.</p>
        <p v-if="requestEndMessage" v-html="requestEndMessage"></p>
        <hr>
          <p>
              Encontrou problemas? <a :href="'mailto:' + mailContact">Contacte-nos</a>
          </p>
          <p class="lead">
              <router-link class="btn btn-primary btn-lg" role="button" :to="{name: 'UserProfile'}" >Ir para a página inicial</router-link>
              <router-link class="btn btn-primary btn-lg btn-danger" role="button" to="/login?ex=1" @click.native="logout" >Sair do sistema</router-link>
          </p>
      </div>
      <div class="col-md-4">
        <i class="glyphicon glyphicon-ok-circle success"></i>
      </div>
    </div>
    <div v-else class="row">
      <div class ="col-md-8">
        <h1 class="display-3">Ops</h1>
        <h3 class="display-5">Algo deu errado e não foi possível confirmar a submissão!</h3>
        <p class="lead"><strong>Favor tentar novamente.</strong></p>
        <hr>
          <p>
              Encontrou problemas? <a :href="'mailto:' + mailContact">Contacte-nos</a>
          </p>
          <p class="lead">
              <router-link class="btn btn-primary btn-lg" role="button" :to="{name: 'UserProfile'}" >Ir para a página inicial</router-link>
          </p>
      </div>
      <div class="col-md-4">
        <i class="glyphicon glyphicon-remove-circle fail"></i>
      </div>
    </div>
  </div>
</div>
</template>

<script>

  import moment from 'moment'
  import { Parse } from '../Global'
  import { handleParseError } from './util/ErrorHandling'
  
  moment.locale('pt-br')

  export default {
    data () {
      return {
        user: Parse.User.current(),
        requestId: undefined,
        isConfirmed: undefined,
        mailContact: 'cadt@reitoria.ifpe.edu.br',
        requestEndMessage: ''
      }
    },
    mounted () {
      this.requestId = this.$route.params.requestId
      this.getConfirmation(this.$route.params.requestId)
    },
    methods: {
      getConfirmation (requestId) {
        let self = this
        self.loading = true
        let params = {
          requestId: requestId
        }
        Parse.Cloud.run('isRequestConfirmed', params).then((res) => {
          self.loading = false
          self.isConfirmed = true
          if (res.mailContact) {
            self.requestEndMessage = res.requestEndMessage
            self.mailContact = res.mailContact
          }
        }).fail(error => {
          self.loading = false
          self.isConfirmed = false
          handleParseError(self, error)
        })
      },
      logout () {
        let self = this
        if (self.user.getEmail() !== self.user.getUsername()) {
          location.href = 'https://acesso.ifpe.edu.br/realms/master/protocol/openid-connect/logout?redirect_uri=https://workflow.ifpe.edu.br'
        }
        Parse.User.logOut()
        this.loggedUser = null
        this.adminUser = false
        this.numberOfLinkedRequests = 0
      }
    }
  }

</script>

<style scoped>
.modal-container {
  padding-bottom: 25px;
  padding-left: 25px;
}
.success {
    color: darkgreen;
    font-size: 300px;
}
.fail {
    color: darkred;
    font-size: 300px;
}
</style>



// WEBPACK FOOTER //
// RequestConfirmation.vue?08789b3c